import React from 'react';
import hoc from './FieldHOC';
import moment from 'moment';

let DatePicker;

class DateField extends React.Component {
  constructor(props) {
    super(...arguments);
    if (!DatePicker){
      require(/* webpackPrefetch: true */ ['react-bootstrap-date-picker-pf'], (D) => {
        if (!DatePicker){
          DatePicker = D;
          this.forceUpdate();
        }
      });
    }
    this.state = {
      value: props.value || ''
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.setState({
      value: value
    }, () => {
      this.props.onChange(value);
    });
  }

  render() {
    let value = this.state.value ? moment(this.state.value).toISOString() : null;
    let saveValue = this.state.value ? moment(this.state.value).format('MM/DD/YYYY') : '';

    return (
      <div tabIndex={this.props.tabIndex}>
        <label>{this.props.title || this.props.field.get('title')}</label>
        <input type="hidden" value={saveValue} name={this.props.name} disabled={this.props.disabled} />
        {this.props.errorComponent}
        {DatePicker ? <DatePicker
          disabled={this.props.disabled}
          onChange={this.onChange}
          dateFormat={this.props.dateFormat}
          value={value}
          calendarContainer={document.body}
        /> : null}
      </div>
    );
  }
}

export default hoc(DateField);
